import { Controller } from "@hotwired/stimulus"
import { TurboConfirm } from "@rolemodel/turbo-confirm"

const tc = new TurboConfirm({
  dialogSelector: '#confirm',
  acceptSelector: '#confirm-accept',
  denySelector: '.confirm-cancel',
  activeClass: 'in',
  showConfirmCallback: () => window.$('#confirm').modal('show'),
  hideConfirmCallback: () => window.$('#confirm').modal('hide'),
})

export default class extends Controller {
  dirty = false

  connect() {
    this.dirty = false
    this.element.addEventListener('change', this.markDirty)
    this.element.addEventListener('input', this.markDirty)
    this.element.addEventListener('hugerte:dirty', this.markDirty)
    this.element.addEventListener('map:dirty', this.markDirty)
    this.element.addEventListener('submit', this.markClean)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    document.addEventListener('turbo:before-visit', this.handleBeforeVisit)
  }

  disconnect() {
    this.element.removeEventListener('change', this.markDirty)
    this.element.removeEventListener('input', this.markDirty)
    this.element.removeEventListener('hugerte:dirty', this.markDirty)
    this.element.removeEventListener('map:dirty', this.markDirty)
    this.element.removeEventListener('submit', this.markClean)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    document.removeEventListener('turbo:before-visit', this.handleBeforeVisit)
  }

  markDirty = () => { this.dirty = true }

  markClean = () => { this.dirty = false }

  handleBeforeUnload = (event) => {
    if (!this.dirty) return
    event.preventDefault()
    event.returnValue = ''
  }

  handleBeforeVisit = async (event) => {
    if (!this.dirty) return
    event.preventDefault()
    const url = event.detail.url
    const confirmed = await tc.confirmWithContent({
      '#confirm-title': 'You have unsaved changes',
      '#confirm-body': '<p>Your changes will be lost if you leave this page. Are you sure you want to continue?</p>',
    })
    if (confirmed) {
      this.markClean()
      window.Turbo.visit(url)
    }
  }
}
